import { render, staticRenderFns } from "./EarningsTop.vue?vue&type=template&id=745b45da&scoped=true"
import script from "./EarningsTop.vue?vue&type=script&lang=js"
export * from "./EarningsTop.vue?vue&type=script&lang=js"
import style0 from "./EarningsTop.vue?vue&type=style&index=0&id=745b45da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b45da",
  null
  
)

export default component.exports